import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GanttViewIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GanttView",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 5.57h11.43V9H3z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.43 10.14H3c-.63 0-1.14-.51-1.14-1.14V5.57c0-.63.51-1.14 1.14-1.14h11.43c.63 0 1.14.51 1.14 1.14V9c0 .63-.51 1.14-1.14 1.14M4.14 7.86h9.14V6.72H4.14zM12.14 14.71h16v3.43h-16z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M28.14 19.29h-16c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h16c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14M13.29 17H27v-1.14H13.29zM3 23.86h16v3.43H3z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 28.43H3c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h16c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14M4.14 26.14h13.71V25H4.14zM24.71 11.29c-.63 0-1.14-.51-1.14-1.14V1a1.14 1.14 0 1 1 2.28 0v9.14c0 .63-.51 1.14-1.14 1.14ZM24.71 31.86c-.63 0-1.14-.51-1.14-1.14v-8a1.14 1.14 0 1 1 2.28 0v8c0 .63-.51 1.14-1.14 1.14"
    })]
  }));
};
GanttViewIcon.displayName = 'GanttViewIcon';